import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../mappers/valley-popup-status-mapper";
import * as i2 from "../data.requirements";
export class GetValleyPopupStatusUseCase {
    constructor(mapper, data) {
        this.mapper = mapper;
        this.data = data;
    }
    run(data) {
        return this.data.getValleyPopupStatus(data).pipe(this.mapper.map);
    }
}
GetValleyPopupStatusUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GetValleyPopupStatusUseCase_Factory() { return new GetValleyPopupStatusUseCase(i0.ɵɵinject(i1.ValleyPopupStatusMapper), i0.ɵɵinject(i2.DataRequirementsInjectionToken)); }, token: GetValleyPopupStatusUseCase, providedIn: "root" });
